import api_request from "../utility/api-request";
import NotificationAPI from "../api/NotificationAPI";

export default class NotificationService {
  static getNotification(property) {
    console.log(property);

    return api_request({
      url: `${NotificationAPI.API_ROOT_URL}/getNotification`,
      method: "POST",
      data: { data: property },
    });
  }
}
